"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  default: () => src_default
});
module.exports = __toCommonJS(src_exports);
var ENV = {
  API_ENDPOINT: process.env.NEXT_PUBLIC_API_ENDPOINT,
  FLASK_API_ENDPOINT: process.env.NEXT_PUBLIC_FLASK_API_ENDPOINT,
  // Mapbox
  MAPBOX_DEBOUNCE_DELAY: Number(
    process.env.NEXT_PUBLIC_MAPBOX_DEBOUNCE_DELAY || 1e3
  ),
  MAPBOX_MIN_SEARCH_LENGTH: Number(
    process.env.NEXT_PUBLIC_MAPBOX_MIN_SEARCH_LENGTH || 2
  ),
  MAPBOX_ACCESS_TOKEN: process.env.NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN || "",
  MAPBOX_LANGUAGE: process.env.NEXT_PUBLIC_MAPBOX_LANGUAGE || "en",
  MAPBOX_LIMIT: Number(process.env.NEXT_PUBLIC_MAPBOX_LIMIT || 10),
  MAPBOX_BASE_URL: process.env.NEXT_PUBLIC_MAPBOX_BASE_URL || "https://api.mapbox.com",
  MAPBOX_ENDPOINTS: {
    FORWARD_GEOCODING: process.env.NEXT_PUBLIC_MAPBOX_FORWARD_GEOCODING_ENDPOINT || "/search/searchbox/v1/forward"
  },
  NEXT_PUBLIC_CHATBOT_ENDPOINT_URL: process.env.NEXT_PUBLIC_CHATBOT_ENDPOINT_URL || "https://copilotkit-runtime.vercel.app",
  NEXT_PUBLIC_SEARCH_ENDPOINT_URL: process.env.NEXT_PUBLIC_SEARCH_ENDPOINT_URL || "https://granbull-space-copilot-runtime.vercel.app",
  NEXT_PUBLIC_FIREBASE_API_KEY: process.env.NEXT_PUBLIC_FIREBASE_API_KEY || "",
  NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN || "",
  NEXT_PUBLIC_FIREBASE_PROJECT_ID: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || "",
  NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET || "",
  NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || "",
  NEXT_PUBLIC_FIREBASE_APP_ID: process.env.NEXT_PUBLIC_FIREBASE_APP_ID || "",
  NEXT_PUBLIC_ALLOW_EMAIL_SIGN_IN: process.env.NEXT_PUBLIC_ALLOW_EMAIL_SIGN_IN || "",
  NEXT_PUBLIC_AGENT_ENDPOINT: process.env.NEXT_PUBLIC_AGENT_ENDPOINT || ""
};
var src_default = ENV;
